module.exports = __webpack_public_path__ + "img/IOT.15c44754.svg";